import { Helmet } from 'react-helmet-async';
import metadata from '../metadata';
import { useLocation } from 'react-router-dom';

export default function Meta() {
  const location = useLocation();

  const hostname = window.location.hostname;
  const domain = metadata[hostname] ? hostname : 'excent.capital';

  // console.log('[META] Hostname detectado:', hostname);
  // console.log('[META] Dominio en uso:', domain);

  // Detectar lang del path (primer segmento)
  const match = location.pathname.match(/^\/(en|es|pt|fr|it|zh)\//);
  const lang = match ? match[1] : 'en'; // fallback
  //  console.log('[META] Idioma detectado:', lang);

  // Normalizar path (sin lang)
  const pathWithoutLang = location.pathname.replace(/^\/(en|es|pt|fr|it|zh)/, '');
  const path = pathWithoutLang.endsWith('/') ? pathWithoutLang : pathWithoutLang + '/';
  // console.log('[META] Path normalizado:', path);

  // Construir key: "en/trading/commission/"
  const metaKey = `${lang}${path}`;
  // console.log('[META] Clave de metadata generada:', metaKey);

  const meta = metadata[domain]?.[metaKey] || {};
  // console.log('[META] Objeto de metadata obtenido:', meta);

  return (
    <Helmet>
      {meta.title && <title>{meta.title}</title>}
      {meta.description && <meta name="description" content={meta.description} />}
      {meta.keywords && <meta name="keywords" content={meta.keywords} />}
      {meta.robots && <meta name="robots" content={meta.robots} />}
      {meta.canonical && <link rel="canonical" href={meta.canonical} />}
      {meta.alternates &&
        Object.entries(meta.alternates).map(([langCode, href]) => (
          <link key={langCode} rel="alternate" hrefLang={langCode} href={href} />
        ))}
      {meta.openGraph?.title && <meta property="og:title" content={meta.openGraph.title} />}
      {meta.openGraph?.description && <meta property="og:description" content={meta.openGraph.description} />}
      {meta.openGraph?.url && <meta property="og:url" content={meta.openGraph.url} />}
      {meta.openGraph?.type && <meta property="og:type" content={meta.openGraph.type} />}
      {meta.openGraph?.image && <meta property="og:image" content={meta.openGraph.image} />}
      {meta.openGraph?.imageWidth && <meta property="og:image:width" content={meta.openGraph.imageWidth} />}
      {meta.openGraph?.imageHeight && <meta property="og:image:height" content={meta.openGraph.imageHeight} />}
      {meta.twitter?.card && <meta name="twitter:card" content={meta.twitter.card} />}
      {meta.twitter?.title && <meta name="twitter:title" content={meta.twitter.title} />}
      {meta.twitter?.description && <meta name="twitter:description" content={meta.twitter.description} />}
      {meta.twitter?.image && <meta name="twitter:image" content={meta.twitter.image} />}
    </Helmet>
  );
}
